export default {
  page_title: 'Réapprovisionnements',
  page_description: 'Gérer les réapprovisionnements de ressources consommables',
  add_refill: 'Ajouter un Réapprovisionnement',
  edit_refill: 'Modifier le Réapprovisionnement',
  editTitle: 'Modifier le Réapprovisionnement',
  editSubtitle: 'Mettre à jour les informations du réapprovisionnement',
  resource: 'Ressource',
  user: 'Utilisateur',
  quantity_added: 'Quantité Ajoutée',
  refilled_date: 'Date de Réapprovisionnement',
  current_quantity: 'Quantité Actuelle',
  notes: 'Notes',
  notes_placeholder: 'Entrez des notes sur ce réapprovisionnement...',
  quantity_to_add: 'Quantité à Ajouter',
  add: 'Ajouter',
  edit: 'Modifier',
  added_successfully: 'Réapprovisionnement ajouté avec succès',
  updated_successfully: 'Réapprovisionnement mis à jour avec succès',
  invalid_quantity: 'La quantité doit être supérieure à 0',
  unknown_resource: 'Ressource Inconnue',
  unknown_user: 'Utilisateur Inconnu',
  units: 'unités'
};
